import AddBoxIcon from "@material-ui/icons/AddBox";
import Button from "@mui/material/Button";
import React from "react";
import strings from "../../config/localization";

interface Props {
  onClickHandler?: () => void;
  label?: string;
  size?: "medium" | "small" | "large" | undefined;
  id?: string;
}

export default function NewButton({
  onClickHandler = () => {},
  label = strings.new,
  size = "medium",
  id = "newButton",
}: Props) {
  return (
    <Button
      variant="outlined"
      size={size}
      id={id}
      startIcon={<AddBoxIcon />}
      onClick={onClickHandler}
    >
      {label}
    </Button>
  );
}
